import { Fragment } from 'react';
import gettext from '@sdk/lang/gettext';
import { Collapsible } from '@sdk/components/Collapsible/Collapsible';

import { GroupHeader } from './GroupHeader';
import { MembersList } from './MembersList';
import { useConversationMembers } from './conversationMembers.hooks';
import { Group, Header, Wrapper } from './conversationMembers.styles';

export const ConversationMembers = () => {
  const { directMembers, groups } = useConversationMembers();

  return (
    <Wrapper>
      <Header>{gettext('Added members')}</Header>

      {groups.map((group) => (
        <Fragment key={group.id}>
          <Collapsible isActive={false}>
            <GroupHeader>{group.displayName}</GroupHeader>

            <Collapsible.Content>
              <Group>
                <MembersList items={group.members} />
              </Group>
            </Collapsible.Content>
          </Collapsible>
        </Fragment>
      ))}

      <MembersList items={directMembers} />
    </Wrapper>
  );
};
